<template>
  <div class="p-4 sm:my-8 sm:rounded-lg sm:shadow-lg bg-white sm:max-w-4xl sm:mx-auto">
    <template v-if="loading">
      <p>Подождите, идёт загрузка.</p>
    </template>
    <error404 v-else-if="error" />
    <order v-else-if="order" :order="order" :dashboard-prefix="dashboardPrefix" />
  </div>
</template>

<script>
import axios from '@/zenky'
import config from '@/zenky/config'
import Order from '@/components/orders/Order.vue'
import Error404 from '@/pages/errors/404'

export default {
  props: {
    orderParams: {
      required: true,
      type: String,
    },
  },

  components: {
    Order,
    Error404,
  },

  created() {
    if (!this.parseData()) {
      return
    }

    this.loadOrder()
  },

  methods: {
    parseData() {
      let params = null

      try {
        params = atob(this.orderParams)
      } catch (e) {
        this.error = true

        return false
      }

      if (!params || typeof params !== 'string') {
        this.error = true

        return false
      }

      const pieces = params.split(';')

      if (!Array.isArray(pieces) || pieces.length !== 4) {
        this.error = true

        return false
      }

      this.storeId = pieces[0]
      this.orderId = pieces[1]
      this.orderToken = pieces[2]
      this.dashboardPrefix = pieces[3]

      return true
    },

    async loadOrder() {
      if (this.loading || !this.orderId) {
        return
      }

      this.loading = true

      try {
        const response = await axios.get(`orders/${this.orderId}?token=${this.orderToken}&with=${config.inclusions.order}`, {
          headers: { 'X-Store-Id': this.storeId },
        })

        this.order = response.data.data
      } catch (e) {
        this.error = true
      } finally {
        this.loading = false
      }
    },
  },

  data() {
    return {
      storeId: null,
      orderId: null,
      orderToken: null,
      dashboardPrefix: null,
      order: null,
      loading: false,
      error: false,
    }
  }
}
</script>
